var _path, _path2, _path3, _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconColors = function SvgIconColors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.8,
    d: "m9.23 6.367 4.488-2.591a2 2 0 0 1 2.732.732l9.657 16.725 1.057 1.832a2 2 0 0 1-.732 2.732l-3.58 2.067-1.764 1.019a2 2 0 0 1-2.732-.732l-1.498-2.594"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.8,
    d: "m14.134 3.803 4.775-1.28a2 2 0 0 1 2.45 1.415l4.488 16.751m.788 2.94.27 1.007a2 2 0 0 1-1.415 2.45l-5.96 1.597a2 2 0 0 1-2.45-1.414l-.595-2.22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.8,
    d: "M26.121 21.052V4.889a2 2 0 0 0-2-2h-4.902"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.371,
    height: 23.628,
    x: 4.273,
    y: 12.025,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.8,
    rx: 1.1,
    transform: "rotate(-45 4.273 12.025)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.981,
    cy: 22.814,
    r: 1.643,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.8,
    transform: "rotate(-45 20.98 22.814)"
  })));
};
export { SvgIconColors as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMiAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMjI5MzQgNi4zNjcxNUwxMy43MTggMy43NzU2NEMxNC42NzQ2IDMuMjIzMzYgMTUuODk3NyAzLjU1MTExIDE2LjQ1IDQuNTA3NjlMMjYuMTA2NiAyMS4yMzM0TDI3LjE2NDIgMjMuMDY1M0MyNy43MTY1IDI0LjAyMTggMjcuMzg4OCAyNS4yNDUgMjYuNDMyMiAyNS43OTczTDIyLjg1MTcgMjcuODY0NUwyMS4wODc2IDI4Ljg4M0MyMC4xMzEgMjkuNDM1MyAxOC45MDc5IDI5LjEwNzUgMTguMzU1NiAyOC4xNTA5TDE2Ljg1NzkgMjUuNTU2OCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS44IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTE0LjEzMzUgMy44MDMzOEwxOC45MDkxIDIuNTIzNzdDMTkuOTc2IDIuMjM3ODggMjEuMDcyNyAyLjg3MTA1IDIxLjM1ODUgMy45Mzc5OEwyNS44NDcgMjAuNjg5MU0yNi42MzQ2IDIzLjYyODZMMjYuOTA0NiAyNC42MzYyQzI3LjE5MDUgMjUuNzAzMiAyNi41NTczIDI2Ljc5OTkgMjUuNDkwNCAyNy4wODU3TDE5LjUyOTMgMjguNjgzQzE4LjQ2MjQgMjguOTY4OSAxNy4zNjU3IDI4LjMzNTcgMTcuMDc5OCAyNy4yNjg4TDE2LjQ4NDggMjUuMDQ4MiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS44IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTI2LjEyMSAyMS4wNTE4VjQuODg4NjdDMjYuMTIxIDMuNzg0MSAyNS4yMjU2IDIuODg4NjcgMjQuMTIxIDIuODg4NjdIMTkuMjE5IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cmVjdCB4PSI0LjI3Mjc5IiB5PSIxMi4wMjU0IiB3aWR0aD0iOC4zNzEzNyIgaGVpZ2h0PSIyMy42Mjg0IiByeD0iMS4xIiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgNC4yNzI3OSAxMi4wMjU0KSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS44IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPGNpcmNsZSBjeD0iMjAuOTgwNiIgY3k9IjIyLjgxMzUiIHI9IjEuNjQyODQiIHRyYW5zZm9ybT0icm90YXRlKC00NSAyMC45ODA2IDIyLjgxMzUpIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";